import { createFileRoute } from '@tanstack/react-router';

import { BillingPage } from '@/pages/billing/ui/billing-page';

import { AppLayout } from '../-components/app-layout';

export const Route = createFileRoute('/_authenticated/$mallId/billing/')({
  component: BillingRoute,
});

function BillingRoute() {
  return (
    <AppLayout pageTitle="플랜 및 결제">
      <BillingPage />
    </AppLayout>
  );
}
